import { ICommandBase } from '@/commands/interface/iCommandBase';
import { Design } from '@/model/document2/page/surface/design/design';

// デザインの回転コマンド
export class RotateDesignCommand implements ICommandBase
{
    private design! : Design;
    private delta! : number;
    private doneCallback! : () => void;

    constructor(design : Design, delta : number, doneCallback : () => void)
    {
        this.design = design;
        this.delta = delta;
        this.doneCallback = doneCallback;
    }

    public do() : void
    {
        // デザインを回転
        this.design.rotateDesign(this.delta);
        
        this.doneCallback();
    }

    public undo() : void
    {
        // デザインを逆回転
        this.design.rotateDesign(-this.delta);

        this.doneCallback();
    }

    public redo() : void
    {
        // デザインを回転
        this.design.rotateDesign(this.delta);

        this.doneCallback();
    }
}
